import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./index.module.css";
import { BooksFeed } from "@/03-widgets/books-feed";
import { OrdersFeed } from "@/03-widgets/orders-feed";
import { Topbar } from "@/03-widgets/topbar";
export const HomePage = ({}) => {
    return (_jsxs("div", { className: styles.pageWrapper, children: [_jsx(Topbar, {}), _jsxs("main", { className: styles.content, children: [_jsx(BooksFeed, {}), _jsx(OrdersFeed, {})] })] }));
};
